import bg from "../../../assets/bg-realestate-cta.png";

const AboutCTA = ({
    onPostProperty,
    onGoHome,
}) => {
    return (
        <section
            className="relative h-[500px] bg-cover bg-center flex items-center justify-center"
            style={{
                backgroundImage: `url(${bg})`,
            }}
        >
            <div className="absolute inset-0 bg-black/50" />

            <div className="relative z-10 text-center text-white px-4">
                <h2 className="text-4xl font-bold mb-6">
                    Khám phá cơ hội bất động sản cùng Mỹ Diệp
                </h2>

                <p className="text-lg mb-8">
                    Dù bạn là nhà đầu tư hay khách hàng tìm kiếm tổ ấm,
                    Mỹ Diệp luôn sẵn sàng đồng hành cùng bạn.
                </p>

                <div className="flex flex-col md:flex-row gap-4 justify-center">
                    <button
                        onClick={onPostProperty}
                        className="bg-[#c9a063] text-[#082f49] px-6 py-3 rounded-lg"
                    >
                        Đăng tin bán ngay
                    </button>

                    <button
                        onClick={onGoHome}
                        className="bg-[#082f49] text-white px-6 py-3 rounded-lg"
                    >
                        Tìm nhà/mua ngay
                    </button>
                </div>
            </div>
        </section>
    );
};

export default AboutCTA;